import CompaniesFormComponent from 'components/marketingSite/companies2/CompaniesFormComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect, useState } from 'react';
import { ServiceServicePublicStats } from 'services/service.public-stats';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type CompaniesFormPageProps = WithBaseUrl & { manfreditesCount: number };

const parseJSON = (resp: any): any => (resp.json ? resp.json() : resp);

const checkStatus = (resp: any): any => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp: any) => {
    throw resp;
  });
};

const headers = { 'Content-Type': 'application/json' };

const CompaniesFormPage: React.FC<CompaniesFormPageProps> = ({
  baseUrl,
  manfreditesCount
}) => {
  const { t } = useI18n('companies2');

  usePageTrack('Landing - Page Loaded');

  const [stats, setStats] = useState([]);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    fetch(`https://cms.getmanfred.com/api/companies-page-stats`, {
      headers,
      method: 'GET'
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setStats(data));
  }, []);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/companies-page-customers?populate=%2A&pagination[pageSize]=100`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setCustomers(data));
  }, []);

  return (
    <>
      <HeadMetadata
        title={t('companies.page_title')}
        desc={t('companies.page_description')}
        url={APP_URLS.companiesForm}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_companies_form.png'
        )}`}
      />
      <CompaniesFormComponent
        stats={stats}
        manfreditesCount={manfreditesCount}
        customers={customers}
      />
    </>
  );
};

export default CompaniesFormPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const { manfreditesCount } = await ServiceServicePublicStats.get();

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'companies2'
      ])),

      baseUrl: config.appUrl,
      manfreditesCount
    },
    revalidate: 30
  };
};
